document.addEventListener('click', function (event) {
    var videoItem = event.target.closest('.social-media-feed-item__video');
    if (videoItem) {
        var videoId = videoItem.getAttribute('data-video-id');
        if (videoId) {
            openVideoModal(videoId);
        }
    }
});

document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.social-media-feed__video-close');
    if (closeBtn) {
        closeVideoModal();
    }
});

function openVideoModal(videoId) {
    var modal = document.querySelector('.social-media-feed__video-modal');
    var iframe = modal.querySelector('.social-media-feed__iframe');
    iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&loop=0&background=0&title=0"}';
    modal.style.display = 'block';
}

function closeVideoModal() {
    var modal = document.querySelector('.social-media-feed__video-modal');
    var iframe = modal.querySelector('.social-media-feed__iframe');
    iframe.src = '';
    modal.style.display = 'none';
}
